import React from "react";

import { useBackground } from "./hooks";

export const Background = React.memo(() => {
  const { getBackgroundProps, values } = useBackground();
  return (
    <div {...getBackgroundProps()}>
      <div className={values.styles.jaw} />
      <div className={values.styles.main} />
    </div>
  );
});

Background.displayName = "Background";
